export default ({ IDL }) => {
  const Time = IDL.Int;
  const User = IDL.Record({
    'id' : IDL.Nat,
    'principal' : IDL.Text,
    'date' : Time,
    'name' : IDL.Text,
  });
  return IDL.Service({
    'newScore' : IDL.Func([IDL.Text, IDL.Text, IDL.Nat], [], ['oneway']),
    'register' : IDL.Func(
        [IDL.Text, IDL.Text],
        [IDL.Bool, IDL.Bool, IDL.Nat],
        [],
      ),
    'topScores' : IDL.Func(
        [],
        [IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat)))],
        ['query'],
      ),
    'userInfo' : IDL.Func([IDL.Text], [IDL.Bool, IDL.Opt(User)], ['query']),
  });
};
export const init = ({ IDL }) => { return []; };